import React from 'react';
import PropTypes from 'prop-types';
import BottomSheet from '../BottomSheet';
import Calculator from '../Calculator';

const CalculatorModal = ({ onClose, onUseValue }) => (
  <BottomSheet
    title="Calculadora"
    subtitle={onUseValue ? 'Calcule e envie o resultado para o campo de valor.' : 'Faça uma conta rápida sem sair do Nara.'}
    onClose={onClose}
    size="calculator"
    className="nf-sheet-backdrop--nested"
  >
    <Calculator
      onUseValue={onUseValue ? (value) => {
        onUseValue(value);
        onClose();
      } : undefined}
    />
  </BottomSheet>
);

CalculatorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onUseValue: PropTypes.func,
};

export default CalculatorModal;